import { get } from "lodash";
import moment from "moment-timezone";

// -- VALIDATION UTILS -- //

export function getErrorStateFromProps(props) {
  const {
    field: { name },
    form: { touched, errors },
    apiErrors
  } = props;

  return (
    get(touched, name, null) &&
    (!!get(errors, name, null) || !!get(apiErrors, name, null))
  );
}

export function getErrorStateFromPropsByName(name, props) {
  const {
    form: { touched, errors },
    apiErrors
  } = props;

  return (
    get(touched, name, null) &&
    (!!get(errors, name, null) || !!get(apiErrors, name, null))
  );
}

export function getCompleteState(requiredFields, fields) {
  return requiredFields.reduce((accumulator, field) => {
    // if even one field isn't valid we aren't complete
    if (accumulator === false) return false;

    const fieldObj = fields[field];
    const valid = fieldObj ? fieldObj.valid : false;

    return valid;
  }, true);
}

export function createDataBlock(id, fields, complete, updateEstimate) {
  return {
    id,
    fields,
    complete,
    updateEstimate: updateEstimate || false
  };
}

export function createInputObject(value, valid, data) {
  return {
    value,
    valid,
    ...data
  };
}

export function getFieldValidityState(name, copyKey, fields, props) {
  const { isError, error, copy } = props;

  const localError = !get(fields, `${name}.valid`, true);
  const localSuccess = get(fields, `${name}.valid`, false);

  let message = localError
    ? copy(`forms.validation_requirements.${copyKey}`)
    : "";

  let serverError = false;
  let serverSuccess = true;

  if (isError && error && error.violations) {
    const item = error.violations.find(item => item.propertyPath === name);
    serverError = item !== undefined;
    serverSuccess = item === undefined;
    message = get(item, "message", message);
  }

  return {
    success: localSuccess && serverSuccess,
    error: localError || serverError,
    message
  };
}

export function getISOWeek(ISOString) {
  return {
    from: moment.utc(ISOString).startOf("isoWeek").toISOString(),
    to: moment.utc(ISOString).endOf("isoWeek").toISOString()
  };
}
